import styled from "styled-components";

export const StyledStatusWrapperCell = styled.div`
    display: flex;
    flex-direction: column;

    & > div {
        align-self: flex-start;
        display: inline-block;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        padding: 4px 6px;
        border-radius: 8px;

        &:not(:last-child) {
            margin-bottom: 8px;
        }
    }
`;
